import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

export const initGA = () => {
  if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== '') {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log('✅ Google Analytics 4 initialized');
  } else {
    console.warn('⚠️ Google Analytics 4 not configured. Add REACT_APP_GA4_MEASUREMENT_ID to .env');
  }
};

export const logPageView = (page, title) => {
  if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== '') {
    ReactGA.send({ hitType: 'pageview', page, title });
  }
};

export const logEvent = (category, action, label = null, value = null) => {
  if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== '') {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
  }
};

// Predefined events for common actions
export const trackButtonClick = (buttonName) => {
  logEvent('User Interaction', 'Button Click', buttonName);
};

export const trackMachineView = (machineName) => {
  logEvent('Machine', 'View Machine', machineName);
};

export const trackContactFormSubmit = () => {
  logEvent('Contact', 'Submit Form', 'Contact Form');
};

export const trackBlogView = (blogTitle) => {
  logEvent('Blog', 'View Article', blogTitle);
};

export const trackDevisRequest = () => {
  logEvent('Conversion', 'Request Quote', 'Demander un devis');
};

export default {
  initGA,
  logPageView,
  logEvent,
  trackButtonClick,
  trackMachineView,
  trackContactFormSubmit,
  trackBlogView,
  trackDevisRequest
};
